import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { FormikProvider, useFormik } from 'formik';
import React, { useEffect } from 'react';
import { ContasPagarAction, useContasPagar } from '../../store';
import ContasPagarBuscaAvancadaForm from '../ContasPagarBuscaAvancadaForm';

const ContasPagarBuscaAvancadaModal = () => {
  const [state, dispatch] = useContasPagar();
  const { buscaAvancada, filtroAvancado, requestParams } = state;

  const formatarFiltroAvancado = (values) => {
    const filtro = {
      categoriaId: values?.categoria?.id,
      contaId: values?.conta?.id,
      dataPagamentoInicio: values?.dataPagamentoInicio ? values?.dataPagamentoInicio.format('YYYY-MM-DD') : undefined,
      dataPagamentoFim: values?.dataPagamentoFim ? values?.dataPagamentoFim.format('YYYY-MM-DD') : undefined,
      dataLiquidacaoInicio: values?.dataLiquidacaoInicio
        ? values?.dataLiquidacaoInicio.format('YYYY-MM-DD')
        : undefined,
      dataLiquidacaoFim: values?.dataLiquidacaoFim ? values?.dataLiquidacaoFim.format('YYYY-MM-DD') : undefined,
      dataEmissao: values?.dataEmissao?.format('YYYY-MM-DD'),
      dataVencimentoInicio: values?.dataVencimentoInicio
        ? values?.dataVencimentoInicio.format('YYYY-MM-DD')
        : undefined,
      dataVencimentoFim: values?.dataVencimentoFim ? values?.dataVencimentoFim.format('YYYY-MM-DD') : undefined,
      despesasRegulares: values?.despesasRegulares,
      documentoFiscal: values?.documentoFiscal ? values?.documentoFiscal : undefined,
      formaPagamento: values?.formaPagamento ? values?.formaPagamento : undefined,
      fornecedorId: values?.fornecedor?.id,
      mesCompetencia: values?.mesCompetencia?.format('YYYY-MM-DD'),
      origemLancamento: values?.origemLancamento ? values?.origemLancamento : undefined,
      situacao: values?.situacao ? values?.situacao : undefined,
      valor: values?.valor,
    };
    ContasPagarAction.setFiltroAvancadoFormatado(dispatch, filtro);

    return filtro;
  };

  const handleCancelar = () => {
    ContasPagarAction.fecharModalCadastro(dispatch, formik.dirty);
  };

  const handleSubmit = async (values) => {
    const filtroAvancadoFormatado = formatarFiltroAvancado(values);

    const filtro = {
      ...requestParams,
      ...filtroAvancadoFormatado,
      page: 0,
      query: requestParams.q,
    };

    ContasPagarAction.setFiltroAvancado(dispatch, values);
    ContasPagarAction.setCurrentPage(requestParams.number);
    ContasPagarAction.setPageSize(requestParams.size);
    ContasPagarAction.fecharModalCadastro(dispatch);
    ContasPagarAction.carregarRegistros(dispatch, { ...requestParams, page: 0 }, filtroAvancadoFormatado);
    ContasPagarAction.buscarSomatorio(dispatch, filtro);
  };

  const formik = useFormik({
    initialValues: filtroAvancado,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    if (buscaAvancada) {
      formik.resetForm(filtroAvancado);
    }
    // Reset controlado pelo gatilho acima; incluir o formulário/valores reiniciaria o
    // preenchimento enquanto o usuário edita.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buscaAvancada]);

  return (
    <SimpleDialog open={buscaAvancada} onClose={handleCancelar}>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          header={{
            title: 'Busca avançada',
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" onClick={handleCancelar}>
                  Cancelar
                </CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Aplicar
                </SaveButton>
              </>
            ),
          }}
          content={<ContasPagarBuscaAvancadaForm />}
          contentStyle={{ padding: 0 }}
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default ContasPagarBuscaAvancadaModal;
